import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './index.less'

const VideoScrollerSwipper = ({ sectionId, showPagination = false }) => {
  const DomRef = useRef(null)
  const SwiperDom = useRef(null)
  const SwiperOb = useRef(null)
  const VirtualVideoDom = useRef(null)

  const changeSwipperSlide = () => {
    const scrollTopPosition = window.scrollY
    const targetTopPosition = DomRef.current.offsetTop
    const index = parseInt((scrollTopPosition - targetTopPosition) / VirtualVideoDom.current.offsetHeight)
    const currentIndex = SwiperOb.current.activeIndex
    if (index < 0) {
      // console.log('swipper not scroll to page top: ', index)
      currentIndex != 0 && SwiperOb.current.slideTo(0)
    } else if (index <= SwiperOb.current.slides.length - 1) {
      // console.log('swipper need switch slide: ', index)
      currentIndex != index && SwiperOb.current.slideTo(index)
    } else {
      currentIndex != SwiperOb.current.slides.length - 1 && SwiperOb.current.slideTo(SwiperOb.current.slides.length - 1)
      // console.log('swipper scroll out to page: ', index)
    }
  }

  useEffect(() => {
    DomRef.current = document.querySelector(`[section-id=${sectionId}]`)
    SwiperDom.current = DomRef.current.querySelector('.swiper')
    VirtualVideoDom.current = DomRef.current.querySelector('.virtual-video')
  }, [])

  useEffect(() => {
    if (!window?.XBLOOM3?.Swiper) return

    if (!SwiperDom.current) return
    const swiperPagination = showPagination ? {
      pagination: {
        el: SwiperDom.current.querySelector('.swiper-pagination'),
        clickable: true
      },
    } : {}

    SwiperOb.current = new window.XBLOOM3.Swiper(SwiperDom.current, {
      direction: 'vertical',
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: '1',
      spaceBetween: 0,
      loop: false,
      ...swiperPagination,
      on: {
        slideChange: function () {
          const playVideo = this?.visibleSlides?.[0]?.querySelector('video') ?? {}
          playVideo.currentTime = 0
        }
      }
    })

    if (!SwiperOb?.current) return

    document.addEventListener('scroll', changeSwipperSlide)
    changeSwipperSlide()

    return () => {
      document.removeEventListener('scroll', changeSwipperSlide)
    }

  }, [])

  return (
    <div></div>
  )
}

window.XBLOOM3.DefineXbloomSectionReactComponent('video-scroller-swipper', VideoScrollerSwipper, ReactDOM)